export const BRANCH_SETTINGS = "branch-settings";
export const SERVICES_REQUESTS = "service-requests";
export const SERVICES = "services";
export const ANALYTHICS = "analytics";
export const ASSIGNEE = "assignee";
export const BUSINESS_PROFILE = "business-profile";
export const BRANCH_AND_MANAGERS_MANAGMENT = "branch-and-managers-management";
